export default {
  setApplicationsListState(context, list) {
    context.list = list;
  },
  setApplicationsMetaState(context, meta) {
    context.meta = meta;
  },
  mutateApplicationsLoadingState(context, loading) {
    context.loading = loading;
  },
  mutateApplicationsErrorState(context, error) {
    context.error = error;
  },
  mutateCreateApplicationLoadingState(context, loading) {
    context.createLoading = loading;
  },
  mutateCreatePreApplicationLoadingState(context, loading) {
    context.createPreApplicationLoading = loading;
  },
  mutateAddApplicationToListState(context, application) {
    context.list.unshift(application);
  }
};
